module.exports = __webpack_public_path__ + "img/thumbnail_AldabraGiantTortoise_j_albino.0864f4f4.png";